export default __webpack_public_path__ + "static/media/calendar.f9fa473e.svg";